import axios from 'axios';
import { useEffect, useState } from 'react';

interface useGetRegionProps {
  latitude: undefined | string;
  longitude: undefined | string;
}

interface useGetRegionReturn {
  isGetRegionRequestSuccess: undefined | boolean;
  region: undefined | string;
  regionDepth1: undefined | string;
  regionDepth2: undefined | string;
  regionDepth3: undefined | string;
}

export const useGetRegion = ({ latitude, longitude }: useGetRegionProps): useGetRegionReturn => {
  const [region, setRegion] = useState<undefined | string>();
  const [regionDepth1, setRegionDepth1] = useState<undefined | string>();
  const [regionDepth2, setRegionDepth2] = useState<undefined | string>();
  const [regionDepth3, setRegionDepth3] = useState<undefined | string>();

  const [isGetRegionRequestSuccess, setIsGetRegionRequestSuccess] = useState<boolean>();

  const mapApi = async () => {
    try {
      await axios
        .get(`https://dapi.kakao.com/v2/local/geo/coord2address.json?x=${longitude}&y=${latitude}&input_coord=WGS84`, {
          headers: {
            Authorization: 'KakaoAK f4ff128c3d0357d16c74acc8e00f3e8c',
          },
        })
        .then((response) => {
          const location = response.data.documents[0];
          const si = location.address.region_1depth_name;
          const gu = location.address.region_2depth_name;
          const dong = location.address.region_3depth_name;

          setRegionDepth1(si);
          setRegionDepth2(gu);
          setRegionDepth3(dong);

          const regionDepthList = [si, gu, dong];

          setRegion(regionDepthList.join(' '));
          setIsGetRegionRequestSuccess(true);
        });
    } catch (error: any) {
      setIsGetRegionRequestSuccess(false);
    }
  };

  useEffect(() => {
    if (latitude && longitude) {
      mapApi();
    }
  }, [latitude, longitude]);

  return { isGetRegionRequestSuccess, region, regionDepth1, regionDepth2, regionDepth3 };
};
